/**
 * 지도 핀에 그릴 카테고리 아이콘 고르기 — **순수 함수**.
 *
 * 상품 지도는 소분류 아이콘을 쓴다(09-23 결정). 중분류로 그리면 핀의 92%(dev 기준
 * 269곳 중 247곳)인 스쿠터·오토바이 지점이 전부 중분류 `50-01`(스쿠터·바이크)의
 * **자동차** 아이콘으로 보였다. 지점 허브는 이미 소분류를 쓰고 있어 두 지도가 같아진다.
 *
 * 규칙은 "같은 종류면 한 장, 다르면 종류만큼(최대 3장)"이다. 종류는 **코드가 아니라
 * 그림**으로 가른다 — 소분류 58개 중 14개는 부모 중분류와 같은 그림이라, 코드로만
 * 중복을 걸러 내면 같은 아이콘이 두 장 겹쳐 보인다.
 */
export function pickPinIconCodes<I>(
  codes: readonly string[],
  iconOf: (code: string) => I,
  max = 3,
): string[] {
  const seen = new Set<I>();
  const picked: string[] = [];

  for (const code of codes) {
    if (!code) continue;
    const icon = iconOf(code);
    if (seen.has(icon)) continue;
    seen.add(icon);
    picked.push(code);
    if (picked.length >= max) break;
  }

  return picked;
}
